/* src/app/private/configrations/pipeline-configuration/add-pipeline/add-pipeline.component.scss */
.dialog-content {
  padding: 1.5rem;
}
.dialog-content .dialog-header {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
}
.dialog-content .dialog-header h3 {
  margin: 0 0 0.5rem 0;
  color: var(--primary-color);
}
.dialog-content .dialog-header p {
  margin: 0;
}
.dialog-content .form-content {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 0.5rem;
}
.dialog-content .form-content .form-field {
  margin-bottom: 1.5rem;
}
.dialog-content .form-content .form-field .form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #495057;
}
.dialog-content .stages-section {
  margin-top: 2rem;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 8px;
}
.dialog-content .stages-section h4 {
  margin: 0;
  color: var(--primary-color);
}
.dialog-content .stages-section .stages-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.dialog-content .stages-section .stages-list .stage-item {
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 1rem;
  transition: all 0.3s ease;
}
.dialog-content .stages-section .stages-list .stage-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.dialog-content .stages-section .stages-list .stage-item.stage-default {
  border-left: 4px solid var(--primary-color);
  background: #f0f7ff;
}
.dialog-content .stages-section .stages-list .stage-item .stage-content {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}
.dialog-content .stages-section .stages-list .stage-item .stage-content .stage-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--primary-color);
  color: white;
  font-weight: bold;
  flex-shrink: 0;
  margin-top: 1.5rem;
}
.dialog-content .stages-section .stages-list .stage-item .stage-content .stage-fields {
  display: flex;
  gap: 1rem;
  flex: 1;
  flex-wrap: wrap;
}
.dialog-content .stages-section .stages-list .stage-item .stage-content .stage-fields .form-field {
  margin-bottom: 0;
}
.dialog-content .stages-section .stages-list .stage-item .stage-content .stage-fields .form-field.flex-1 {
  flex: 1;
  min-width: 200px;
}
.dialog-content .stages-section .stages-list .stage-item .stage-content .stage-fields .form-field.score-field {
  width: 180px;
}
.dialog-content .stages-section .stages-list .stage-item .stage-content .stage-fields .form-field.score-field .score-input {
  width: 100px;
}
.dialog-content .stages-section .stages-list .stage-item .stage-content .stage-fields .form-field.score-field .score-display {
  font-weight: 600;
  color: var(--primary-color);
  font-size: 1.1rem;
}
.dialog-content .stages-section .stages-list .stage-item .stage-content .stage-fields .stage-actions {
  display: flex;
  align-items: flex-end;
  padding-bottom: 0.25rem;
}
.dialog-content .stages-section .stages-list .stage-item .stage-content .stage-fields .stage-actions .default-badge {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  cursor: help;
}
.dialog-content .stages-section .stages-list .no-stages {
  text-align: center;
  padding: 2rem;
  background: white;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
}
.dialog-content .stages-section .stages-list .no-stages p {
  margin: 0;
}
.dialog-content .dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #dee2e6;
}
::ng-deep .p-inputtext:disabled,
::ng-deep .p-inputtext[readonly] {
  background-color: #e9ecef;
  opacity: 0.7;
}
/*# sourceMappingURL=add-pipeline.component.css.map */
